<div class="card p-3 p-md-4 order-summary">
    <div class="order-summary-header pb-3">
        <div class="order-summary-meta">
            <ng-container *ngIf="showTitle">
                <h4 class="order-summary-reference m-0 p-0">{{ "Order ref" | translate: { ref: order.ref } }}</h4>
            </ng-container>
            <ng-container *ngIf="showDetailButton">
                <a
                    class="btn btn-sm btn-link-primary order-summary-detail-link"
                    [routerLink]="'/profile/orders/' + order.ref"
                    [attr.aria-label]="'Details' | translate"
                    [attr.title]="'Details' | translate"
                >
                    <i class="bi bi-eye" aria-hidden="true"></i>
                </a>
            </ng-container>
        </div>
        <div class="order-summary-secondary">
            <div class="order-summary-date small text-muted" *ngIf="showTitle">{{ order.createdAt | date: "short" }}</div>
        </div>
        <span class="order-summary-status" [class]="order.statusColor">{{ order.statusFormatted | translate }}</span>
    </div>
    <div class="d-flex gap-2 flex-column">
        <div class="separator"></div>

        <ng-container *ngFor="let item of order.items">
            <div class="order-summary-item">
                <app-picture [picture]="item.offer.medias[0]" size="75"></app-picture>
                <div class="order-summary-item-content">
                    <h5 class="m-0 p-0">
                        <a [routerLink]="['/offers', item.offer.id + '-' + item.offer.slug]">{{ item.offer.name }}</a>
                    </h5>
                    <p class="text-muted m-0 p-0">
                        <app-variant-name [variant]="item.variant"></app-variant-name>
                    </p>
                    <div class="order-summary-item-meta">
                        <span>
                            <span class="fw-bold">{{ "Quantity" | translate }}:</span>&nbsp;
                            <span>{{ item.quantity }}</span>
                        </span>
                        <span class="order-summary-item-price">
                            <app-price [price]="item.totalPriceObject" [convert]="false"></app-price>
                        </span>
                    </div>
                </div>
            </div>
            <div class="separator"></div>
        </ng-container>
    </div>
    <div class="order-summary-totals d-flex justify-content-end align-items-end mt-3 gap-1 flex-column">
        <table class="order-summary-totals-table">
            <tr>
                <td class="text-right pe-3">{{ "Total without taxes" | translate }}</td>
                <td class="text-right"><app-price [price]="order.totalWithoutTaxesPriceObject" [convert]="false"></app-price></td>
            </tr>
            <ng-container *ngFor="let tax of order.taxes">
                <tr>
                    <td class="text-right pe-3">{{ "VAT -rate-" | translate: { rate: tax.rate / 100 } }}</td>
                    <td class="text-right"><app-price [price]="tax.amountPriceObject" [convert]="false"></app-price></td>
                </tr>
            </ng-container>
            <tr>
                <td class="text-right pe-3">{{ "Delivery fee" | translate }}</td>
                <td class="text-right"><app-price [price]="order.deliveryTotalPriceObject" [convert]="false"></app-price></td>
            </tr>
            <tr class="order-summary-total-row">
                <td class="fw-bold text-right pe-3">{{ "Total" | translate }}</td>
                <td class="fw-bold"><app-price [price]="order.totalPriceObject" [convert]="false"></app-price></td>
            </tr>
        </table>
    </div>
</div>
